import type {
  ServerTestRequest,
  ServerTestResponse,
} from "@/app/servers/types";
import type { ApiClient } from "@/lib/api";

export const testServer = async (options: {
  client: ApiClient;
  request: ServerTestRequest;
}): Promise<ServerTestResponse> => {
  const { client, request } = options;
  const { data } = await client.post<ServerTestResponse>(
    "/workers/test",
    request
  );
  return data;
};
